import React from 'react';
import { SwitchField } from 'ui/FormElement';

function RenewalNotification(props) {
  const { typeView, isDisabled, ...rest } = props;

  return (
    <SwitchField name="renewal_notification" />
  );
}

export default RenewalNotification;
